export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8465.57604de2.jpg";